import {
  LEARNING_SEQUENCE_CONCLUSION_CATEGORIES,
  LEARNING_SEQUENCE_INTRODUCTION_CATEGORIES,
  LEARNING_SEQUENCE_QUESTION_CATEGORIES,
} from 'global/constants';
import type { OutcomesFragment } from '../graphql/outcomes/outcomes.graphql.generated';
import type { LessonTeachingLearningSequenceFragment } from '../../lesson/sections/teaching-learning-sequence/teaching-learning-sequence.graphql.generated';
import type { GetLessonTeachingAndLearningSequenceQuery } from '../../activity-builder/components/teaching-notes/teaching-notes.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export const MAX_SEQUENCE_QUESTIONS = 100;

export type TeachingAndLearningOutcome = OutcomesFragment & {
  description: string;
  type: string | null;
};

export type TeachingAndLearningCategoryOptions =
  | typeof LEARNING_SEQUENCE_INTRODUCTION_CATEGORIES
  | typeof LEARNING_SEQUENCE_QUESTION_CATEGORIES
  | typeof LEARNING_SEQUENCE_CONCLUSION_CATEGORIES;

export type TeachingLearningConnections = Pluck<
  LessonTeachingLearningSequenceFragment,
  'teachingAndLearningSequence.connections'
>;

export const ENGLISH_CONNECTION = 'ELA Connections';
export const MATH_CONNECTION = 'Math Connections';

export type TeachingAndLearningSequence =
  | Pluck<LessonTeachingLearningSequenceFragment, 'teachingAndLearningSequence'>
  | Pluck<
      GetLessonTeachingAndLearningSequenceQuery,
      'getLessonTeachingAndLearningSequence'
    >;
